// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ToolList_container__YZwcM {
  max-width: 600px;
  margin: 0 auto;
  padding: 24px 0;
.ToolList_toolList__AroAl {
  list-style: none;
  padding: 0;
  margin: 0;
}
.ToolList_toolItem__YQ2sc {
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
  background: #fff;
}
.ToolList_toolName__a43-f {
  font-size: 1.2em;
  font-weight: bold;
  margin-bottom: 4px;
}
.ToolList_toolGenre__Lf1PZ, .ToolList_toolBrand__r7jk\\+, .ToolList_toolColor__Odkl7 {
  font-size: 0.98em;
  color: #555;
  margin-bottom: 2px;
}
.ToolList_imagePreviewArea__LlUhB {
  display: flex;
  gap: 8px;
  margin-top: 8px;
}
.ToolList_imagePreview__OyHVa {
  width: 48px;
  height: 48px;
  object-fit: cover;
  border-radius: 4px;
  border: 1px solid #eee;
}

.ToolList_button__EphnM {
  display: inline-block;
  background: linear-gradient(90deg, #4f8cff 0%, #2357c5 100%);
  color: #fff;
  font-weight: bold;
  border: none;
  border-radius: 24px;
  padding: 10px 28px;
  font-size: 1em;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(79,140,255,0.08);
  transition: background 0.2s, box-shadow 0.2s, transform 0.1s;
}
.ToolList_button__EphnM:hover, .ToolList_button__EphnM:focus {
  background: linear-gradient(90deg, #2357c5 0%, #4f8cff 100%);
  box-shadow: 0 4px 16px rgba(79,140,255,0.16);
  transform: translateY(-2px) scale(1.03);
}
}
`, "",{"version":3,"sources":["webpack://./src/Page/Tools/ToolList.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,4DAA4D;EAC5D,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,2CAA2C;EAC3C,4DAA4D;AAC9D;AACA;EACE,4DAA4D;EAC5D,4CAA4C;EAC5C,uCAAuC;AACzC;AACA","sourcesContent":[".container {\r\n  max-width: 600px;\r\n  margin: 0 auto;\r\n  padding: 24px 0;\r\n.toolList {\r\n  list-style: none;\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n.toolItem {\r\n  border: 1px solid #ddd;\r\n  border-radius: 8px;\r\n  padding: 16px;\r\n  margin-bottom: 16px;\r\n  background: #fff;\r\n}\r\n.toolName {\r\n  font-size: 1.2em;\r\n  font-weight: bold;\r\n  margin-bottom: 4px;\r\n}\r\n.toolGenre, .toolBrand, .toolColor {\r\n  font-size: 0.98em;\r\n  color: #555;\r\n  margin-bottom: 2px;\r\n}\r\n.imagePreviewArea {\r\n  display: flex;\r\n  gap: 8px;\r\n  margin-top: 8px;\r\n}\r\n.imagePreview {\r\n  width: 48px;\r\n  height: 48px;\r\n  object-fit: cover;\r\n  border-radius: 4px;\r\n  border: 1px solid #eee;\r\n}\r\n\r\n.button {\r\n  display: inline-block;\r\n  background: linear-gradient(90deg, #4f8cff 0%, #2357c5 100%);\r\n  color: #fff;\r\n  font-weight: bold;\r\n  border: none;\r\n  border-radius: 24px;\r\n  padding: 10px 28px;\r\n  font-size: 1em;\r\n  cursor: pointer;\r\n  box-shadow: 0 2px 8px rgba(79,140,255,0.08);\r\n  transition: background 0.2s, box-shadow 0.2s, transform 0.1s;\r\n}\r\n.button:hover, .button:focus {\r\n  background: linear-gradient(90deg, #2357c5 0%, #4f8cff 100%);\r\n  box-shadow: 0 4px 16px rgba(79,140,255,0.16);\r\n  transform: translateY(-2px) scale(1.03);\r\n}\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ToolList_container__YZwcM`,
	"toolList": `ToolList_toolList__AroAl`,
	"toolItem": `ToolList_toolItem__YQ2sc`,
	"toolName": `ToolList_toolName__a43-f`,
	"toolGenre": `ToolList_toolGenre__Lf1PZ`,
	"toolBrand": `ToolList_toolBrand__r7jk+`,
	"toolColor": `ToolList_toolColor__Odkl7`,
	"imagePreviewArea": `ToolList_imagePreviewArea__LlUhB`,
	"imagePreview": `ToolList_imagePreview__OyHVa`,
	"button": `ToolList_button__EphnM`
};
export default ___CSS_LOADER_EXPORT___;
